import Button from '@carvana/ds-button';
import Finance from '@carvana/ds-icons/FinanceSpot';
import { icon } from '@carvana/ds-styles';
import TrackWrapper from '@/common/TrackWrapper';
import formatEvent from '~/utilities/formatEvent';
import {
  DefaultCardContainer,
  DefaultCardContent,
  DefaultCardHeading,
  DefaultCardBody
} from './SharedCard.styles';

type OwnProps = {
  onCtaClick: React.MouseEventHandler;
};

export default function DefaultFinanceCard({ onCtaClick }: OwnProps) {
  const commonCustomAttributes = {
    description: 'Finance card',
    status: 'default',
    cta: 'get pre-qualified'
  };

  return (
    <TrackWrapper
      event={formatEvent('Home feed card', {
        action: 'viewed',
        ...commonCustomAttributes
      })}
      trackOnce
      key="finance-default"
    >
      <DefaultCardContainer data-testid="finance-card-pre-qualified">
        <div className="flex items-center gap-xl">
          <div className="shrink-0">
            <Finance aria-hidden="true" size={56} color={icon.inverse} />
          </div>
          <DefaultCardContent>
            <DefaultCardHeading>Finance with Carvana</DefaultCardHeading>
            <DefaultCardBody>
              No hit to your credit, see real monthly payments while shopping.
            </DefaultCardBody>
          </DefaultCardContent>
        </div>

        <Button
          className="w-full"
          data-analytics-id="Home feed card"
          data-analytics-attributes={JSON.stringify({
            ...commonCustomAttributes,
            item: 'cta button'
          })}
          data-testid="finance-card-cta-default"
          onClick={onCtaClick}
          size="sm"
          variant="primaryInverted"
        >
          Get Pre-Qualified
        </Button>
      </DefaultCardContainer>
    </TrackWrapper>
  );
}
